const API_URL = `${process.env.REACT_APP_API_URL}/api`;
console.log(process.env.REACT_APP_API_URL);


export default class AuthService {

  static async login(email, mot_de_passe_h) {
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ email, mot_de_passe_h }),
      });

      const data = await response.json();

      if (response.status === 403 && data.reset_required) {
        return data;
      }

      if (!response.ok) {
        console.error("Erreur API :", {
          status: response.status,
          message: data.message,
          details: data,
        });
        throw new Error(data.message || "Email ou mot de passe incorrect");
      }
      return data;
    } catch (error) {
      throw new Error(error.message || "Impossible de se connecter au serveur");
    }
  }


  static async register(nom, email, mot_de_passe_h, cguAccepted) {
    try {
      const response = await fetch(`${API_URL}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          nom,
          email,
          mot_de_passe_h,
          cgu_accepted: cguAccepted, 
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erreur lors de l'inscription");
      }

      return data;
    } catch (error) {
      throw new Error(error.message || "Impossible de se connecter au serveur");
    }
  }
  static async resetPassword({ email, password, cgu_accepted }) {
    try {
      const response = await fetch(`${API_URL}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          cgu_accepted,  
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erreur lors de la réinitialisation");
      }

      return data;
    } catch (error) {
      throw new Error(error.message || "Impossible de se connecter au serveur");
    }
  }

  static getApiUrl(userRole) {
    return userRole === 'admin' ? `${API_URL}/admin` : `${API_URL}/gestionnaire`;
  }

  static async logout(userRole) {
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("Token manquant. Impossible de se déconnecter.");
    }

    const apiUrl = this.getApiUrl(userRole);

    try {
      const response = await fetch(`${apiUrl}/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erreur lors de la déconnexion");
      }

      return data;
    } catch (error) {
      throw new Error(error.message || "Impossible de contacter le serveur");
    }
  }


  static async forgotPassword(email) {
    try {
      const response = await fetch(`${API_URL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Impossible d'envoyer le lien de réinitialisation");
      }

      return data;
    } catch (error) {
      throw new Error(error.message || "Erreur réseau lors de l'envoi du lien");
    }
  }

  static async updatePassword({ email, token, password, password_confirmation }) {
    try {
      const response = await fetch(`${API_URL}/update-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email,
          token,
          password,
          password_confirmation
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erreur lors de la mise à jour du mot de passe");
      }

      return data;
    } catch (error) {
      throw new Error(error.message || "Impossible de contacter le serveur");
    }
  }

  static async getEmailFromToken(token) {
    try {
      const response = await fetch(`${API_URL}/get-email-from-token`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ token }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Token invalide ou expiré");
      }

      return data.email;
    } catch (error) {
      throw new Error(error.message || "Impossible de vérifier le lien");
    }
  }
}
